import { HYDRATE_STATE } from "commons/src/reducers/indexActions";

import { SET_ADVISER_DETAILS, SET_ADVISER_LOCATION } from "./adviserActions";

export const adviser = (state = {}, action) => {
    switch (action.type) {
        case SET_ADVISER_DETAILS:
            return { ...state, adviser: action.details };

        case SET_ADVISER_LOCATION: {
            return { ...state, adviser: { ...state.adviser, location: action.location } };
        }

        case HYDRATE_STATE:
            return {
                ...state,
                ...action.newState.adviser
            };

        default:
            return state;
    }
};
